'use client'

import { useTheme, ColorMode } from '@vinted/web-ui'

const useIsDarkMode = () => useTheme().mode === ColorMode.Dark

export default useIsDarkMode
